module.exports = __webpack_public_path__ + "img/logo.68edaeb5.png";